'use client'

import { Button } from '@mantine/core'
import { Component, ErrorInfo, ReactNode } from 'react'

interface Props {
  children: ReactNode
  fallback?: ReactNode
}

interface State {
  hasError: boolean
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(): State {
    // Update state so next render shows fallback UI
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback || (
          <div
            className='flex flex-col items-center justify-center min-h-screen'
            style={{ minHeight: '80vh' }}
          >
            <h2 className='text-xl font-semibold'>
              Oops, Something went wrong.
            </h2>
            <Button
              onClick={() => this.setState({ hasError: false })}
              className='mt-4 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition'
            >
              Try Again
            </Button>
          </div>
        )
      )
    }
    return this.props.children
  }
}
